// Module
var code = "<react-component name=\"ArchivedWaiversList\"></react-component>\n";
// Exports
module.exports = code;